module.exports = __webpack_public_path__ + "static/media/steve-jobs.12471b5e.jpg";